<template>
  <a :href="hrefSignIn">{{ labelSignIn }}</a>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { SIGNIN_URL, SIGNOUT_URL } from "../constants";
import eventBus from "../eventBus";
export default {
  name: "SignLink",
  data: function() {
    return {
      labelSignIn: "",
      hrefSignIn: ""
    };
  },
  created() {
    this.$store.dispatch("cognito/refreshToken");
    if (this.$store.getters["cognito/getStatusToken"]) {
      this.toggleSignOut();
    } else {
      this.toggleSignIn();
    }
  },
  mounted() {
    eventBus.$on("TOKEN_UPDATED", payload => {
      this.toggleSignOut(payload);
    });
    eventBus.$on("TOKEN_REMOVED", payload => {
      this.toggleSignIn(payload);
    });
  },
  computed: {
    ...mapGetters(["cognito/getPayload", "cognito/getStatusToken"])
  },
  methods: {
    ...mapActions(["cognito/refreshToken"]),

    toggleSignIn: function() {
      this.labelSignIn = "Sign In";
      this.hrefSignIn = SIGNIN_URL;
    },

    toggleSignOut: function() {
      this.labelSignIn = "Sign Out";
      this.hrefSignIn = SIGNOUT_URL;
    }
  }
};
</script>
